/* eslint-disable no-console */
import { apiUri } from '@config';
import { codeMap } from '@constants/code';
import { createSurvey, updateSurvey } from '@graphql/mutations';
import { getSurvey } from '@graphql/queries';
import { API, graphqlOperation } from 'aws-amplify';
import _ from 'lodash';
import moment from 'moment';

export const getExpiredDtAPI = async (params: { id: string }): Promise<any> => {
  const { id } = params;
  // const id = '0758986240'; // test id

  try {
    let response = {};
    const requestOptions = {
      method: 'GET',
      headers: new Headers(),
    };

    await fetch(`${apiUri?.getSurvey}?otp=${id}`, requestOptions)
      .then((r) => r.json())
      .then((r) => {
        if (r.expriedStatus) {
          response = { expriedStatus: true };
        } else if (r.progressingTreatmentFlag) {
          response = { progressingTreatmentFlag: true };
        } else {
          response = {
            id,
            surveyType: r.surveyType,
            clinic: r.clinic.clinicName,
            patient: {
              birth: r.patient.birth,
              gender: r.patient.gender,
              patientName: r.patient.patientName,
            },
          };
        }
      })
      .catch((e) => console.log(e));

    return response;
  } catch (error) {
    console.error('ERROR!', error);
  }
  return false;
};

export const getSurveyAPI = async (params: { id: string }): Promise<any> => {
  const { id } = params;
  try {
    const response = await API.graphql(graphqlOperation(getSurvey, { id }));
    return response;
  } catch (error) {
    console.error('ERROR!', error);
  }

  return false;
};

// 현중님이 survey 데이터 세팅해주기전의 테스트용 API
export const postSurveyAPI = async (param = {}): Promise<any> => {
  try {
    const response = await API.graphql(
      graphqlOperation(createSurvey, {
        input: {
          ...param,
          mainSymptom: '',
          visitCount: 0,
          firstLinkClickDt: Number(moment().format('X')),
          completedDt: 0,
        },
      }),
    );
    return response;
  } catch (error) {
    console.error('ERROR!', error);
  }

  return false;
};

export const updateSurveyAPI = async (
  params: {
    id?: string;
    completedDt?: number;
    rawData?: any;
    reviewRating?: number;
    reviewComment?: string;
    reviewFlag?: boolean;
    mode?: string;
    _version?: number;
    byeonjeungData?: string;
    recommendHerbs?: string;
    solutionClickCount?: number;
    surveyType?: string;
  } = {},
): Promise<any> => {
  try {
    if (params.surveyType !== 'B2C' && params?.completedDt > 0 && !params.reviewFlag) {
      // 설문 완료 일시가 찍히는 것을 설문 완료 시점으로 본다.
      const formData = JSON.parse(params?.rawData);
      const keys = Object.keys(formData);
      const survey = keys
        .filter((k: string) => codeMap.has(k))
        .map((k: string) => {
          const v = formData?.[k];
          const result = {
            code: k,
            value: v,
            desc: '',
          };
          if (_.isArray(v) && v.includes(-1)) {
            // 주관식 응답값 -1 을 가지고 있다면
            result.desc = formData?.[`${k}Desc`] ?? '';
          } else {
            delete result.desc;
          }
          return result;
        });

      const refinedSurveyResData = {
        mainSymptom: formData?.mainSymptom ?? '',
        additionalSymptoms: formData?.additionalSymptom ?? '',
        survey,
      };

      const body = JSON.stringify({
        otp: formData?._id,
        insuranceType: params?.mode,
        mainSurveyCode: formData?.selectedMainSurveyCode,
        surveyResult: refinedSurveyResData,
      });

      await fetch(`${apiUri?.surveyDone}`, {
        method: 'POST',
        body,
      });
    }
    if (params?.reviewRating) {
      // 만족도 조사
      const body = JSON.stringify({
        otp: params?.id,
        surveyGrade: params?.reviewRating,
        surveySatisfaction: params?.reviewComment ?? '',
      });

      await fetch(`${apiUri?.surveySatisfaction}`, {
        method: 'POST',
        body,
      });
    }
    delete params?.reviewFlag;
    console.log(params);
    const response = await API.graphql({ query: updateSurvey, variables: { input: params } });
    return response;
  } catch (error) {
    console.error('ERROR!', error);
  }
  return false;
};

export const registerMBTIUserAPI = async (input: {
  name: string;
  gender: 'MALE' | 'FEMALE';
  age: number;
  phone: string;
}): Promise<{ uuid: string; success: boolean } | false> => {
  try {
    const query = /* GraphQL */ `
      mutation RegisterMBTIUser($input: RegisterMBTIUserInput!) {
        registerMBTIUser(input: $input) {
          uuid
          success
        }
      }
    `;
    const res: any = await API.graphql(graphqlOperation(query, { input }));
    return res?.data?.registerMBTIUser ?? false;
  } catch (error) {
    console.error('registerMBTIUser ERROR!', error);
    return false;
  }
};

export const getMBTIUserByUuidAPI = async (
  uuid: string,
): Promise<{
  uuid: string;
  name: string;
  gender: 'MALE' | 'FEMALE';
  age: number;
  phone: string;
  completedSurveyId: string | null;
} | null> => {
  try {
    const query = /* GraphQL */ `
      query GetMBTIUserByUuid($uuid: ID!) {
        getMBTIUserByUuid(uuid: $uuid) {
          uuid
          name
          gender
          age
          phone
          completedSurveyId
        }
      }
    `;
    const res: any = await API.graphql(graphqlOperation(query, { uuid }));
    return res?.data?.getMBTIUserByUuid ?? null;
  } catch (error) {
    console.error('getMBTIUserByUuid ERROR!', error);
    return null;
  }
};

export const markMBTIUserCompletedAPI = async (
  uuid: string,
  surveyId: string,
): Promise<{ success: boolean; alreadyCompleted: boolean } | false> => {
  try {
    const query = /* GraphQL */ `
      mutation MarkMBTIUserCompleted($uuid: ID!, $surveyId: ID!) {
        markMBTIUserCompleted(uuid: $uuid, surveyId: $surveyId) {
          success
          alreadyCompleted
        }
      }
    `;
    const res: any = await API.graphql(graphqlOperation(query, { uuid, surveyId }));
    return res?.data?.markMBTIUserCompleted ?? false;
  } catch (error) {
    console.error('markMBTIUserCompleted ERROR!', error);
    return false;
  }
};

export const getByeonjeungResult = async ({
  sCodes,
}: {
  sCodes: { code: string; check: boolean }[];
}): Promise<any> => {
  try {
    const res1 = await (
      await fetch(`https://iuq4joao6vogw4jw362q4vfupe0pidbz.lambda-url.ap-northeast-2.on.aws/`, {
        method: 'POST',
        body: JSON.stringify({
          mode: 'byeonjeung',
          herbCodeArrayforSearch: [],
          processingCodeArrayforSearch: [],
          symptoms: sCodes,
        }),
      })
    ).json();
    const res2 = await (
      await fetch(`https://umd7o64uvr725e4kkaejjlz4kq0ipcdg.lambda-url.ap-northeast-2.on.aws/`, {
        method: 'POST',
        body: JSON.stringify({
          herbs:
            // @ts-ignore
            (JSON.parse(res1?.body ?? '{}')?.herbs ?? [])?.map((h) => ({
              code: h.code,
              relativeSymptomCode: h.relativeSymptomCode,
              score: h.weight,
            })) ?? [],
        }),
      })
    ).json();
    // @ts-ignore
    return {
      팔강: res2?.팔강점수 ?? {
        표: 0,
        리: 0,
        한: 0,
        열: 0,
        실: 0,
        허: 0,
      },
      변증: _.values(res2?.변증 ?? {}).map((e: any) => ({ code: e.code, weight: e.weight })),
      약재: (JSON.parse(res1?.body ?? '{}')?.herbs ?? []).map((e: any) => ({
        code: e.code,
        weight: e.weight,
      })),
    };
  } catch (error) {
    console.error('ERROR!', error);
  }
  return false;
};
